import { useEffect, useState } from 'react';
import config from '../../common/config';
import SvgMovie from '../../../components/SvgMovie';

import './styles/Digest12.less';

let timeoutDelayPlay: any;
let timeoutPlayText: any;
const Digest = ({ seq, play = false, onDataLoaded }: any) => {
  const [delayPlay, setDelayPlay] = useState(false);
  const [playText, setPlayText] = useState(false);

  useEffect(() => {
    if (timeoutDelayPlay) {
      clearTimeout(timeoutDelayPlay);
      timeoutDelayPlay = null;
    }
    if (timeoutPlayText) {
      clearTimeout(timeoutPlayText);
      timeoutPlayText = null;
    }

    if (play) {
      timeoutDelayPlay = setTimeout(() => {
        setDelayPlay(true);
      }, 300);

      timeoutPlayText = setTimeout(() => {
        setPlayText(true);
      }, 500);
    } else {
      // 恢复初始化状态
      setDelayPlay(false);
      setPlayText(false);
    }
  }, [play]);

  return (
    <div className={`digest-wrapper digest-wrapper-${seq}`}>
      <SvgMovie
        src={config.slides[seq].svgMovie}
        play={delayPlay}
        className="full-screen-svg"
        onDataLoaded={onDataLoaded}
      />
      <div className={`digest digest-${seq}`}>
        <div className={`text-block ${playText ? 'ani-fade-in' : ''}`}>
          <img className="svg-in-block" src={config.getFullUrl('images/3-ends.svg')} alt="3 ends" />
          <div className="titles">
            <div className="title title-primary">复用一套代码</div>
          </div>
          <div className="description">
            <div>Aurum在架构设计初期就考虑了组件的高度适配。</div>
            <div>PC端共用一套代码组件；小程序&amp;H5共用一套代码。</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digest;
